import { Component, Input } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-xero-reconnect-dialog',
  standalone: true,
  imports: [NbCardModule, NbButtonModule],
  template: `
    <nb-card>
      <nb-card-header>Reconnect Your Xero Account</nb-card-header>
      <nb-card-body>
        <p>Your connection to Xero needs to be renewed to {{ action }}.</p>
        <p>Would you like to reconnect now?</p>
      </nb-card-body>
      <nb-card-footer class="d-flex justify-content-end">
        <button nbButton status="basic" class="mr-2" (click)="cancel()">Cancel</button>
        <button nbButton status="primary" (click)="reconnect()">Reconnect</button>
      </nb-card-footer>
    </nb-card>
  `,
})
export class XeroReconnectDialogComponent {
  @Input() action: string;

  constructor(protected dialogRef: NbDialogRef<XeroReconnectDialogComponent>) {}

  reconnect() {
    this.dialogRef.close('reconnect');
  }

  cancel() {
    this.dialogRef.close('cancel');
  }
}
